import React, { useContext, useState, forwardRef } from 'react';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { Input, Button, Table, GlobalLoading } from '@/shared/components';
import { useMutationSearchResult } from '@/hooks/search-result.hook';
import { TableColumn } from '@/shared/components/Table/use-column';

const BaseNumber = forwardRef<HTMLInputElement>(function BaseNumber(props, ref) {
  const { t } = useLang(NAMESPACE.documentSearch);
  const [baseNumberKey, setBaseNumberKey] = useState('');
  const [lotNumberKey, setLotNumberKey] = useState('');
  const [searchData, setSearchData] = useState<any>({});
  const [noData, setNoData] = useState(false);
  const searchReq = useMutationSearchResult();
  const onSearch = async () => {
    GlobalLoading.show();
    const data = {
      baseNumber: baseNumberKey?.trim(),
      lotNumber: lotNumberKey?.trim(),
    };
    searchReq
      .mutateAsync(data)
      .then((response: any) => {
        GlobalLoading.hide();
        if (response && response?.code === '200' && response?.data?.length > 0) {
          setSearchData(response);
          setNoData(false);
        } else {
          setSearchData({});
          setNoData(true);
        }
      })
      .catch((error) => {
        GlobalLoading.hide();
        setSearchData({});
        setNoData(true);
      });
  };
  const onClear = () => {
    setBaseNumberKey('');
    setLotNumberKey('');
  };
  const columns: TableColumn<any>[] = [
    {
      accessorKey: 'baseNumber',
      header: t('base.number'),
    },
    {
      accessorKey: 'lotNumber',
      header: t('lot.number'),
      style: {
        minWidth: '200px',
      },
    },
    {
      accessorKey: 'releaseDate',
      header: t('release.date'),
    },
    {
      accessorKey: 'retestPeriod',
      header: t('retest.period'),
      style: {
        minWidth: '200px',
      },
    },
    {
      accessorKey: 'suggestedRetestDate',
      header: t('suggested.retest.date'),
      style: {
        minWidth: '200px',
      },
    },
  ];
  return (
    <>
      <div className="flex flex-row gap-2">
        <Input
          placeholder={t('base.number.placeholder')}
          className="min-w-[250px] text-ellipsis"
          label={t('base.number')}
          value={baseNumberKey}
          onChange={(e) => {
            setBaseNumberKey(e.target.value);
          }}
          name="baseNumber"
        />
        <Input
          placeholder={t('lot.number.placeholder')}
          className="min-w-[250px] text-ellipsis"
          value={lotNumberKey}
          label={t('lot.number')}
          onChange={(e) => {
            setLotNumberKey(e.target.value);
          }}
          name="lotNumber"
        />
        <div className="flex justify-center items-center gap-2 pt-6">
          <Button
            className="min-w-[50px]"
            onClick={onSearch}
            type="outline"
            disabled={!(baseNumberKey && lotNumberKey)}
          >
            {t('search')}
          </Button>
          <Button className="min-w-[50px]" onClick={onClear}>
            {t('clear')}
          </Button>
        </div>
      </div>
      {searchData && searchData?.data?.length > 0 && (
        <>
          <Table
            columns={columns}
            dataSource={searchData.data}
            className="w-full min-w-[1300px] document-search-table mt-5"
          ></Table>
        </>
      )}
      {noData && <div className="my-5">{t('no.results')}</div>}
    </>
  );
});
export { BaseNumber };
